export function dataRole(role?: string) {
  return role ? { 'data-role': role } : {};
}
